import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarTimeAddFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 3C16.5523 3 17 3.44772 17 4V5H19C20.1046 5 21 5.89543 21 7V12.5278C19.9385 11.5777 18.5367 11 17 11C13.6863 11 11 13.6863 11 17C11 18.5367 11.5777 19.9385 12.5278 21H5C3.89543 21 3 20.1046 3 19V7C3 5.89543 3.89543 5 5 5H7V4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4V5H15V4C15 3.44772 15.4477 3 16 3ZM17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13ZM17 14.5C16.4872 14.5 16.0645 14.886 16.0067 15.3834L16 15.5V17C16 17.5128 16.386 17.9355 16.8834 17.9933L17 18H18C18.5523 18 19 17.5523 19 17C19 16.4872 18.614 16.0645 18.1166 16.0067L18 16V15.5C18 14.9477 17.5523 14.5 17 14.5ZM8.5 14H8C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H8.5C9.05228 16 9.5 15.5523 9.5 15C9.5 14.4477 9.05228 14 8.5 14ZM11 10H8C7.44772 10 7 10.4477 7 11C7 11.5128 7.38604 11.9355 7.88338 11.9933L8 12H11C11.5523 12 12 11.5523 12 11C12 10.4872 11.614 10.0645 11.1166 10.0067L11 10Z"
	})
});
export default SvgCalendarTimeAddFill;
